import { render } from "./CrudEvaluations.vue?vue&type=template&id=63f0da71"
import script from "./CrudEvaluations.vue?vue&type=script&lang=js"
export * from "./CrudEvaluations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__